<div class="d-flex flex-column align-items-center border-bottom">
    <div class="d-flex flex-column flex-sm-row justify-content-between align-items-center w-100 pb-sm-20-lg-36">
        <div class="d-flex flex-row pb-sm-20">
            <img [id]="'logo'" [src]="logo" class="logo pr-18" />
            <div class="gb-headline3 heavy">
                {{brand.name}}
            </div>
        </div>
        <div (click)="vehicleCta(button1Link)" class="gb-primary-button text-nowrap stat-button-link" [attr.data-dtm]="(brand.name) | lowercase">
            {{button1}} 
            <span class="pl-8">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-up-right"
                    viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                        d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
                    <path fill-rule="evenodd"
                        d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
                </svg>                
            </span>   
        </div>
    </div>
    <!-- Vehicles section -->
    <div class="grid-container w-100">
        @for(vehicle of vehicleList?.slice(0,4); track $index){
        <div class="d-flex flex-column justify-content-center align-items-center pb-sm-20">
            <img [src]="vehicle.images.primary" loading="lazy" class="img-fluid pb-sm-20 pb-8">
            <div class="desc-title pb-24">
                {{vehicle.year}} {{vehicle.model}}
            </div>
            <div (click)="vehicleCta(vehicle.ctaLink)" class="gb-secondary-button text-nowrap stat-button-link" [attr.data-dtm]="(vehicle.year + ' ' + vehicle.model) | lowercase">
                {{button2}}
                <span class="pl-8">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-up-right"
                        viewBox="0 0 16 16">
                        <path fill-rule="evenodd"
                            d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
                        <path fill-rule="evenodd"
                            d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
                    </svg>                    
                </span> 
            </div>
        </div>
        }
    </div>
    @if(viewAll.value){
    <div class="grid-container w-100 pt-16">
        @for(vehicle of vehicleList?.slice(4); track $index){
        <div class="d-flex flex-column justify-content-center align-items-center pb-sm-20">
            <img [src]="vehicle.images.primary" loading="lazy" class="img-fluid pb-sm-20 pb-8">
            <div class="desc-title pb-24">
                {{vehicle.year}} {{vehicle.model}}
            </div>
            <div (click)="vehicleCta(vehicle.ctaLink)" class="gb-secondary-button text-nowrap stat-button-link" [attr.data-dtm]="vehicle.year + ' ' + vehicle.model">
                {{button2}}
                <span class="pl-8">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-up-right"
                        viewBox="0 0 16 16">
                        <path fill-rule="evenodd"
                            d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
                        <path fill-rule="evenodd"
                            d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
                    </svg>                    
                </span> 
            </div>
        </div>
        }
    </div>
    }
    <div class="d-flex flex-row justify-content-start align-items-center w-100 explansion-style pt-25 show-styling" (click)="showAllVehicles()">
        @if(!viewAll.value){
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M2.1084 8.63989H15.4417" stroke="#0072CE" stroke-width="3.5" stroke-linecap="round"/>
                <path d="M8.7749 1.97314L8.7749 15.3065" stroke="#0072CE" stroke-width="3.5" stroke-linecap="round"/>
            </svg>
            <div class="pl-16">
              All {{brand.name}} Vehicles  
            </div>
            
        } @else if(viewAll.value){
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-dash-lg" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8"/>
            </svg>
            <div class="pl-16">
               Show Less  
            </div>
           
        }
    </div>
</div>